import React from "react";
import { Award, Crown, ShieldCheck, Sparkles } from "lucide-react";

// Vendor tier visual mapping. Kept short so it fits inside PropertyCard header.
const TIERS = {
  top:      { label: "Top Vendor", icon: Crown,       cls: "bg-[#C85A32] text-white" },
  trusted:  { label: "Trusted",    icon: Award,       cls: "bg-[#2B3A67] text-white" },
  verified: { label: "Verified",   icon: ShieldCheck, cls: "bg-[#D4DEC6] text-[#2B3A67]" },
  new:      { label: "New",        icon: Sparkles,    cls: "bg-[#F0EBE1] text-[#5C6B7A]" },
};

export default function TierBadge({ tier = "new", compact = false, className = "" }) {
  const meta = TIERS[tier] || TIERS.new;
  const Icon = meta.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded ${compact ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]"} uppercase tracking-[0.16em] font-medium ${meta.cls} ${className}`}
      data-testid={`tier-badge-${tier}`}
      title={`${meta.label} vendor`}
    >
      <Icon size={compact ? 9 : 11} /> {meta.label}
    </span>
  );
}
